import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header border-0 pt-5\"><ul class=\"nav nav-tabs nav-line-tabs mb-5 fs-5\"><li class=\"nav-item\"><a class=\"nav-link disabled\" data-bs-toggle=\"tab\">Jenis Desain</a></li><li class=\"nav-item\"><a href=\"#kt_tab_pane_2\" class=\"nav-link active\" data-bs-toggle=\"tab\">Data Cetak</a></li><li class=\"nav-item\"><a class=\"nav-link disabled\" data-bs-toggle=\"tab\">Konfirmasi Cetak</a></li></ul></div>", 1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_4 = {
  class: "tab-pane fade show active",
  id: "kt_tab_pane_2",
  role: "tabpanel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrintData = _resolveComponent("PrintData")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card mb-12"])
    }, _hoisted_2, 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_PrintData, { onTabChange: _ctx.tabChange }, null, 8, ["onTabChange"])
      ])
    ])
  ], 64))
}